module.exports = __webpack_public_path__ + "media/images/equipments-img-05-6fa66b4d8be62d4468643a34aebef8af.jpg";